import { CourseFormValues, normalizeRequestWithDate } from '@shared';
import { API_ROUTES, request, requestWithPaginationHeader } from '../instance';

export type CourseData = {
  id: number;
  name: string;
  uuid: string;
  description: string | null;
  start: number[] | null;
  end: number[] | null;
};
export type CourseAPI = { course: CourseData; examCount: number; studentCount: number };

export const getPack = (uuid: string, offset = 0, limit: number) => {
  return requestWithPaginationHeader<CourseAPI[]>({
    url: `${API_ROUTES.courses(uuid, offset, limit)}`,
    method: 'GET',
  });
};

export const get = (partner: string, course: string) => {
  return request<CourseAPI>({
    url: `${API_ROUTES.course(partner, course)}`,
    method: 'GET',
  });
};

export const addCourse = (uuid: string, data: CourseFormValues) => {
  return request({
    url: `${API_ROUTES.addCourse(uuid)}`,
    method: 'POST',
    data: normalizeRequestWithDate(data),
  });
};

export const updateCourse = (partner: string, course: string, data: CourseFormValues) => {
  return request({
    url: API_ROUTES.updateCourse(partner, course),
    method: 'PUT',
    data: normalizeRequestWithDate(data),
  });
};
